import { getPredioCaja } from 'api/catastro';
import { getCiudadanoCaja } from 'api/cuentaunicasir/index';
import { getEmpresaCaja } from 'api/empresas';
import { getVehiculoCaja } from 'api/recaudacion/index';
import {
  baseURI as baseURIHospedaje,
  getHospedaje,
  getHospedajeCaja,
  patchHospedaje,
  postHospedaje,
} from 'api/empresas/hospedajes';
import {
  baseURI as baseURIArrendamiento,
  getArrendamiento,
  getArrendamientoCaja,
  patchArrendamiento,
  postArrendamiento,
} from 'api/empresas/arrendamientos';
import {
  baseURI as baseURINomina,
  getNomina,
  getNominaCaja,
  patchNomina,
  postNomina,
} from 'api/empresas/nomina';
import {
  baseURI as baseURIAlcohol,
  getAlcohol,
  getAlcoholCaja,
  patchAlcohol,
  postAlcohol,
} from 'api/empresas/alcoholes';
import {
  baseURI as baseURICedula,
  getCedula,
  getCedulaCaja,
  patchCedula,
  postCedula,
} from 'api/empresas/cedulas';
import {
  baseURI as baseURIJuegoDeAzar,
  getJuegoDeAzar,
  getJuegosDeAzarCaja,
  patchJuegoDeAzar,
  postJuegoDeAzar,
} from 'api/empresas/juegosDeAzar';
import {
  baseURI as baseURINotario,
  getNotario,
  getNotariosCaja,
  patchNotario,
  postNotario,
} from 'api/empresas/notarios';
import {
  baseURI as baseURICasaDeEmpenio,
  getCasaDeEmpenio,
  getCasasDeEmpenioCaja,
  patchCasaDeEmpenio,
  postCasaDeEmpenio,
} from 'api/empresas/casasDeEmpenio';
import {
  baseURI as baseURIAgencia,
  getAgencia,
  getAgenciasCaja,
  patchAgencia,
  postAgencia,
} from 'api/empresas/agencias';
import {
  baseURI as baseURIContribuyente,
  getContribuyente,
  getContribuyenteCaja,
  patchContribuyente,
  postContribuyente,
} from 'api/empresas/contribuyentes';
import {
  baseURI as baseURIMotocicleta,
  getMotocicleta,
  getMotocicletaCaja,
  patchMotocicleta,
  postMotocicleta,
} from 'api/recaudacion/motocicletas';
import {
  baseURI as baseURIRemolque,
  getRemolque,
  getRemolqueCaja,
  patchRemolque,
  postRemolque,
} from 'api/recaudacion/remolque';
import { getCiudadano, postCiudadano, baseURI as baseURICiudadano } from 'api/cuentaunicasir';
import {
  getEmpresa,
  patchEmpresa,
  postEmpresa,
  baseURI as baseURIEmpresa,
} from 'api/empresas/empresas';
import {
  getPredio,
  patchPredio,
  postPredio,
  baseURI as baseURIPredio,
  deletableKeysPredio,
} from 'api/catastro/predio';
import {
  getVehiculo,
  patchVehiculo,
  postVehiculo,
  baseURI as baseURIVehiculo,
} from 'api/recaudacion/vehiculos';
import { patchCiudadano } from 'api/cuentaunicasir/ciudadanos';
import {
  baseURI as baseURIExpedienteDeLicencia,
  getExpedienteDeLicenciaCaja,
  getExpedienteDeLicencia,
  postExpedienteDeLicencia,
  patchExpedienteDeLicencia,
} from 'api/empresas/expedienteDeLicenciaDeFuncionamiento';
import {
  baseURI as baseURIZonaExclusiva,
  getZonaExclusiva,
  getZonasExclusivasCaja,
  patchZonaExclusiva,
  postZonaExclusiva,
} from 'api/empresas/zonasExclusivas';
import {
  baseURI as baseURIExpedienteComercioInformal,
  getExpedienteComercioInformal,
  getExpedientesDeComercioCaja,
  patchExpedienteComercioInformal,
  postExpedienteComercioInformal,
} from 'api/empresas/expedienteDeComercioInformal';
import {
  baseURI as baseURIExpedienteMercado,
  getExpedienteMercado,
  getExpedientesDeMercadoCaja,
  patchExpedienteMercado,
  postExpedienteMercado,
} from 'api/empresas/expedienteDeMercado';
import {
  baseURI as baseURIContratoDePolicia,
  getContratoDePolicia,
  getContratosDePoliciasCaja,
  patchContratoDePolicia,
  postContratoDePolicia,
} from 'api/empresas/contratosDePolicias';
import {
  baseURI as baseURIExpedienteDeAnuncios,
  getExpedienteDeAnuncios,
  getExpedienteDeAnunciosCaja,
  patchExpedienteDeAnuncios,
  postExpedienteDeAnuncios,
} from 'api/empresas/expedienteDeAnuncios';
import {
  getVendedorDeAlcoholes,
  getVendedorDeAlcoholesCaja,
  patchVendedorDeAlcoholes,
  postVendedorDeAlcoholes,
  baseURI as baseURIVendedorDeAlcoholes,
} from 'api/empresas/ventaDeAlcoholes';
import {
  getRetenedorCedula,
  getRetenedorDeCedulaCaja,
  patchRetenedorDeCedula,
  postRetenedorDeCedula,
  baseURI as baseURIRetenedorCedular,
} from 'api/empresas/retenedorDeCedulas';
import {
  getRetenedorDeNomina,
  getRetenedorDeNominaCaja,
  patchRetenedorDeNomina,
  postRetenedorDeNomina,
  baseURI as baseURIRenedorDeNomina,
} from 'api/empresas/retenedorDeNomina';
import {
  getEstacionamiento,
  patchEstacionamiento,
  postEstacionamiento,
  baseURI as baseURIEstacionamiento,
  getEstacionamientoCaja,
} from 'api/empresas/estacionamientos';
import { getPanteon, getPanteonesCaja } from 'api/empresas/panteones';
import {
  baseURI as baseURIExpedienteModulo,
  getExpedienteDeModulo,
  getExpedienteDeModulosCaja,
  patchExpedienteDeModulo,
  postExpedienteDeModulo,
} from 'api/empresas/modulos';
import {
  baseURI as baseURIInfracciones,
  getInfraccion,
  getInfraccionesCaja,
  patchInfraccion,
  postInfracciones,
} from './infracciones';
import {
  baseURI as baseURIMulta,
  getMulta,
  getMultasCaja,
  postMulta,
  patchMulta,
} from './multas';

export const getPadronesMap = {
  1: getCiudadanoCaja,
  2: getEmpresaCaja,
  3: getPredioCaja,
  4: getVehiculoCaja,
  6: getHospedajeCaja,
  7: getArrendamientoCaja,
  8: getNominaCaja,
  9: getAlcoholCaja,
  10: getCedulaCaja,
  11: getJuegosDeAzarCaja,
  12: getNotariosCaja,
  13: getCasasDeEmpenioCaja,
  14: getAgenciasCaja,
  15: getContribuyenteCaja,
  16: getMotocicletaCaja,
  17: getRemolqueCaja,
  18: getContratosDePoliciasCaja,
  19: getInfraccionesCaja,
  20: getExpedientesDeComercioCaja,
  21: getExpedientesDeMercadoCaja,
  22: getExpedienteDeLicenciaCaja,
  23: getZonasExclusivasCaja,
  24: getExpedienteDeAnunciosCaja,
  25: getMultasCaja,
  26: getVendedorDeAlcoholesCaja,
  27: getRetenedorDeCedulaCaja,
  28: getRetenedorDeNominaCaja,
  30: getEstacionamientoCaja,
  31: getPanteonesCaja,
  32: getExpedienteDeModulosCaja,
};

export const retrievePadronesMap = {
  1: getCiudadano,
  2: getEmpresa,
  3: getPredio,
  4: getVehiculo,
  6: getHospedaje,
  7: getArrendamiento,
  8: getNomina,
  9: getAlcohol,
  10: getCedula,
  11: getJuegoDeAzar,
  12: getNotario,
  13: getCasaDeEmpenio,
  14: getAgencia,
  15: getContribuyente,
  16: getMotocicleta,
  17: getRemolque,
  18: getContratoDePolicia,
  19: getInfraccion,
  20: getExpedienteComercioInformal,
  21: getExpedienteMercado,
  22: getExpedienteDeLicencia,
  23: getZonaExclusiva,
  24: getExpedienteDeAnuncios,
  25: getMulta,
  26: getVendedorDeAlcoholes,
  27: getRetenedorCedula,
  28: getRetenedorDeNomina,
  30: getEstacionamiento,
  31: getPanteon,
  32: getExpedienteDeModulo,
};

export const postPadronesMap = {
  1: postCiudadano,
  2: postEmpresa,
  3: postPredio,
  4: postVehiculo,
  6: postHospedaje,
  7: postArrendamiento,
  8: postNomina,
  9: postAlcohol,
  10: postCedula,
  11: postJuegoDeAzar,
  12: postNotario,
  13: postCasaDeEmpenio,
  14: postAgencia,
  15: postContribuyente,
  16: postMotocicleta,
  17: postRemolque,
  18: postContratoDePolicia,
  19: postInfracciones,
  20: postExpedienteComercioInformal,
  21: postExpedienteMercado,
  22: postExpedienteDeLicencia,
  23: postZonaExclusiva,
  24: postExpedienteDeAnuncios,
  25: postMulta,
  26: postVendedorDeAlcoholes,
  27: postRetenedorDeCedula,
  28: postRetenedorDeNomina,
  30: postEstacionamiento,
  32: postExpedienteDeModulo,
};

export const patchPadronesMap = {
  1: patchCiudadano,
  2: patchEmpresa,
  3: patchPredio,
  4: patchVehiculo,
  6: patchHospedaje,
  7: patchArrendamiento,
  8: patchNomina,
  9: patchAlcohol,
  10: patchCedula,
  11: patchJuegoDeAzar,
  12: patchNotario,
  13: patchCasaDeEmpenio,
  14: patchAgencia,
  15: patchContribuyente,
  16: patchMotocicleta,
  17: patchRemolque,
  18: patchContratoDePolicia,
  19: patchInfraccion,
  20: patchExpedienteComercioInformal,
  21: patchExpedienteMercado,
  22: patchExpedienteDeLicencia,
  23: patchZonaExclusiva,
  24: patchExpedienteDeAnuncios,
  25: patchMulta,
  26: patchVendedorDeAlcoholes,
  27: patchRetenedorDeCedula,
  28: patchRetenedorDeNomina,
  30: patchEstacionamiento,
  32: patchExpedienteDeModulo,
};

export const urlsPadronesMap = {
  1: baseURICiudadano,
  2: baseURIEmpresa,
  3: baseURIPredio,
  4: baseURIVehiculo,
  6: baseURIHospedaje,
  7: baseURIArrendamiento,
  8: baseURINomina,
  9: baseURIAlcohol,
  10: baseURICedula,
  11: baseURIJuegoDeAzar,
  12: baseURINotario,
  13: baseURICasaDeEmpenio,
  14: baseURIAgencia,
  15: baseURIContribuyente,
  16: baseURIMotocicleta,
  17: baseURIRemolque,
  18: baseURIContratoDePolicia,
  19: baseURIInfracciones,
  20: baseURIExpedienteComercioInformal,
  21: baseURIExpedienteMercado,
  22: baseURIExpedienteDeLicencia,
  23: baseURIZonaExclusiva,
  24: baseURIExpedienteDeAnuncios,
  25: baseURIMulta,
  26: baseURIVendedorDeAlcoholes,
  27: baseURIRetenedorCedular,
  28: baseURIRenedorDeNomina,
  30: baseURIEstacionamiento,
  32: baseURIExpedienteModulo,
};

export const deletableKeysPadronesMap = {
  3: deletableKeysPredio,
};
